import React from "react";

import { AdminManagement } from "@components/Admin";

export default function AdminIndex() {
  return <AdminManagement />;
}
